import React from "react";
import { StyleSheet, Text, View } from "react-native";

type AttributeCardProps = {
  icon: string;
  title: string;
  value: string;
};

function AttributeCard({
  icon,
  title,
  value,
}: AttributeCardProps): React.JSX.Element {
  return (
    <View style={styles.infoCard}>
      <View style={styles.iconContainer}>
        <Text style={styles.icon}>{icon}</Text>
      </View>
      <View style={styles.textContainer}>
        <Text style={styles.cardTitle}>{title}</Text>
        <Text style={styles.cardValue} numberOfLines={2} ellipsizeMode="tail">
          {value}
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  infoCard: {
    flexDirection: "row",
    alignItems: "center",
    borderRadius: 8,
    padding: 12,
    marginBottom: 12,
    width: "49%",
    backgroundColor: "#f5f5f5",
  },
  iconContainer: {
    marginRight: 12,
  },
  icon: {
    fontSize: 30,
    fontWeight: "bold",
  },
  textContainer: {
    flex: 1,
    overflow: "hidden",
  },
  cardTitle: {
    fontSize: 14,
    fontWeight: "bold",
  },
  cardValue: {
    fontSize: 14,
    color: "#666",
    flexShrink: 1,
  },
});

export default AttributeCard;
